import type {FC} from 'react';
import React, {useEffect} from 'react';
import {useParams} from "react-router";
import serviceConfig from "../ServiceConfig";

const ExternalFlightInput: FC = () => {

    const {tenantId} = useParams();

    useEffect(() => {

    }, []);

    return (<>
        <iframe
            src={`${serviceConfig.serviceBaseUrl}/GetIframe?TenantId=${tenantId?.split('=')[1]}`}
            style={{
                height: 'calc(100vh - 87px)',
                width: '100%',
                border: 'none'
            }}
        >
        </iframe>
    </>);
}

export default ExternalFlightInput;
